var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',[_c('a',{on:{"click":function($event){return _vm.gotoIndex()}}},[_vm._v("首页")])]),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.path))]),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.subPath))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }